module.exports = __webpack_public_path__ + "effb1df87aacef30fdfe1dce9ca4cb2e.png";